import axios from "axios";

export const teslaApi = axios.create({
  baseURL: "https://api.merxenergia.com.br/",
  // baseURL: "https://merx-backend-legado-production.up.railway.app/",
  // baseURL: "https://backend-staging-staging.up.railway.app/",
  // baseURL: "http://localhost:8000/",
});
